import { SceneDescriptor } from '../types'
import { killAvatarOnTouch } from './primitives/killAvatarOnTouch'
import { MissionBehaviors, MissionBehaviorsFactory } from './types'

/**
 * CollectionService タグ → 汎用ギミックのバインディング。
 *
 * ミッション別 TS 実装を持たない外部 rbxl（missionId=EXTERNAL）でも、
 * Studio でタグを付けるだけで主要ギミックが動く経路。タグ規約は
 * 「Robcratch」接頭辞で名前空間を分け、既存ワールドの無関係なタグと
 * 衝突しないようにする。
 *
 * 対応タグ（v1）:
 * - RobcratchTrap: 接触したアバターの体力を 0 にする（→ リスポーン）。
 *   テンプレの TrapScript / AttackScript 相当。
 *
 * 追加候補（要件が出たら）: ワープ（行き先の対応付け規約が必要）、
 * クリア判定など。パラメータが必要なギミックはタグ文字列だけでは
 * 表現できないため、Attributes の読み取り対応とセットで設計する。
 */
export const TAG_TRAP = 'RobcratchTrap'

const hasTag = (tags: readonly string[] | undefined, tag: string): boolean =>
  tags !== undefined && tags.includes(tag)

/**
 * シーン内のタグ付きオブジェクトから汎用ビヘイビアを構成する。
 * 対応タグを持つオブジェクトが 1 つも無ければ undefined
 * （ビヘイビアなしでプレビューを動かす既存挙動に合流）。
 */
export const tagBehaviorsForScene = (
  descriptor: SceneDescriptor,
): MissionBehaviorsFactory | undefined => {
  const trapNames = descriptor.objects
    .filter((object) => hasTag(object.tags, TAG_TRAP))
    .map((object) => object.name)
  if (trapNames.length === 0) {
    return undefined
  }
  return (): MissionBehaviors => ({
    onTouchCharacter: new Map(
      trapNames.map((name) => [name, killAvatarOnTouch]),
    ),
  })
}
